const ROUTES = [
    '/?buy/new/?',
    '/?buy/integrated-services/?',
    '/?buy/homebuying-coach/?',
    '/?buy/join-homebuying-coach/?',
    '/?buy/rewards/?',
    '/?buy/join-rewards/?',
    '/?buy/rewards-fs/?',
    '/?buy/join-rewards-fs/?',
    '/?buy/rewards-fs-fr/?',
    '/?buy/join-rewards-fs-fr/?',
    '/?buy/foyer-homebuyer-savings/?',
    '/?buy/foyer-homebuyer-agent/?',
    '/?buy/?',
    '/?sell/?',
    '/?sell/public-home-listings/?',
    '/?sell/seller-resources/?',
    '/?homeloans/?', // Matches exactly /homeloans/
    '/?homeloans/buyability/.*',
    '/?homeloans/new/?',
    '/?new-construction-advertising/?', // Matches exactly /new-construction-advertising/
    '/?new-construction-advertising/.*', // Matches all sub-paths under /new-construction-advertising/
    // Matches any path that starts with /listing-contact-form/
    '/?listing-contact-form/.*',
    '/?listing-contact-form/?',
];

export function shouldUseVisualRefreshTheme(pathname, query = {}) {
    // Special case for preview
    const previewRegex = new RegExp('^/?preview/*', 'g');
    if (previewRegex.test(pathname?.toLowerCase()) && query?.useVisualRefresh) {
        return true;
    }

    const regex = new RegExp('^(?:' + ROUTES.join('|') + ')$');
    return regex.test(pathname?.toLowerCase());
}

const _zconfigs = {
    prod: {
        serverURLs: {
            MAX: 'https://mortgageapi.zillow.com',
        },
        partnerId: 'RD-WXDQSGN',
    },
    default: {
        serverURLs: {
            MAX: 'https://mortgageapi.qa.zillow.net',
        },
        partnerId: 'RD-GKZRBBL',
    },
};

export function getZmAPIConfig() {
    return _zconfigs[process.env.NEXT_PUBLIC_ENV] || _zconfigs.default;
}
